export { default } from './FormRate';
